// extracted by mini-css-extract-plugin
export var body = "index-module--body--B4T5y";
export var linkStyle = "index-module--linkStyle--ajCTB";
export var rightArrow = "index-module--rightArrow--O+vk3";
export var textCtaContainer = "index-module--textCtaContainer--0w2my";
export var textCtaWrapper = "index-module--textCtaWrapper--o6AKt";
export var titleText = "index-module--titleText--raQtk";